import { render, staticRenderFns } from "./ThePane.vue?vue&type=template&id=59134b46&scoped=true&"
import script from "./ThePane.vue?vue&type=script&lang=ts&"
export * from "./ThePane.vue?vue&type=script&lang=ts&"
import style0 from "./ThePane.vue?vue&type=style&index=0&id=59134b46&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59134b46",
  null
  
)

export default component.exports